"use strict";var n=require("../../Constant/UnknownVersion.cjs");exports.mapToUnknown=function(){return n.UNKNOWN_VERSION};
//# sourceMappingURL=mapToUnknown.cjs.map
